import { Instagram, Mail } from "lucide-react";
import { CONSULTOR, WA_DEFAULT, WHATSAPP_DISPLAY, INSTAGRAM_HANDLE, INSTAGRAM_URL, EMAIL } from "../../data/site";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-graphite pb-10 pt-16 text-stone-400">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-full border border-champagne/40 bg-white/5 font-display text-sm font-semibold text-champagne">
              LR
            </span>
            <span className="leading-tight">
              <span className="block font-display text-base font-semibold tracking-tight text-ink">
                {CONSULTOR.name}
              </span>
              <span className="block font-mono text-[9px] font-semibold uppercase tracking-[0.22em] text-champagne">
                Consultor de Planos de Saúde
              </span>
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed">
            Consultoria especializada em planos de saúde, com atendimento
            personalizado para pessoas, dependentes e empresas.
          </p>
        </div>

        <div>
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-stone-500">
            Modalidades
          </p>
          <p className="mt-4 text-sm font-medium text-stone-300" data-testid="footer-modalities">
            Planos PF • Adesão • Empresarial/PME • Odontológico • Infantil • Terceira Idade
          </p>
          <p className="mt-4 text-xs leading-relaxed">
            Planos regulamentados pela ANS. Disponibilidade, rede credenciada,
            valores, condições comerciais e elegibilidade podem variar conforme
            região, idade, modalidade e perfil de contratação.
          </p>
        </div>

        <div>
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-stone-500">
            Contato
          </p>
          <div className="mt-4 flex flex-col gap-3">
            <a
              href={WA_DEFAULT}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-wa transition-colors duration-300 hover:text-white"
            >
              <WhatsAppIcon className="h-4 w-4" />
              WhatsApp {WHATSAPP_DISPLAY}
            </a>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-stone-300 transition-colors duration-300 hover:text-white"
            >
              <Instagram className="h-4 w-4 text-champagne" />
              Instagram {INSTAGRAM_HANDLE}
            </a>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-stone-300 transition-colors duration-300 hover:text-white"
            >
              <Mail className="h-4 w-4 text-champagne" />
              {EMAIL}
            </a>
          </div>
          <p className="mt-6 text-xs leading-relaxed text-stone-500" data-testid="footer-registry-note">
            Registro profissional e informações regulatórias serão incluídos neste
            espaço quando fornecidos.
          </p>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-6 text-center text-xs text-stone-500">
        © {new Date().getFullYear()} {CONSULTOR.name} — Consultoria em Planos de Saúde. Todos os direitos reservados.
      </div>
    </div>
  </footer>
);
